/**
 * Unstarted work-panel conversations default every member into conversation
 * participation (matching Quick Conversation select-all). Live participant
 * lists are empty in that state and must not clear the default.
 *
 * @param {boolean|null|undefined} hasConversation
 * @param {boolean} isWorkPanelEntity
 * @returns {boolean}
 */
export function shouldPreserveDefaultParticipationForUnstartedWorkPanel(
    hasConversation,
    isWorkPanelEntity,
) {
    return Boolean(isWorkPanelEntity) && !hasConversation;
}

/**
 * Participant IDs to expose on the Members tab after preload when the
 * work-panel conversation has not started yet.
 *
 * @param {Array<{id?: number|string, is_conversation_participant?: boolean}>|null|undefined} roleProfiles
 * @returns {Array<number|string>}
 */
export function resolveUnstartedWorkPanelConversationParticipantIds(
    roleProfiles,
) {
    return (roleProfiles ?? [])
        .filter(
            (roleProfile) =>
                roleProfile?.id != null &&
                Boolean(roleProfile.is_conversation_participant),
        )
        .map((roleProfile) => roleProfile.id);
}
